/* tslint:disable */
/* eslint-disable */
/**
 * Stacks Blockchain API
 * Welcome to the API reference overview for the [Stacks Blockchain API](https://docs.hiro.so/stacks-blockchain-api).  [Download Postman collection](https://hirosystems.github.io/stacks-blockchain-api/collection.json) 
 *
 * The version of the OpenAPI document: STACKS_API_VERSION
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Often times it is useful to return context specific to the request that caused the error (i.e. a sample of the stack trace or impacted account) in addition to the standard error message.
 * @export
 * @interface RosettaErrorDetails
 */
export interface RosettaErrorDetails {
    /**
     * 
     * @type {string}
     * @memberof RosettaErrorDetails
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof RosettaErrorDetails
     */
    error?: string;
}

export function RosettaErrorDetailsFromJSON(json: any): RosettaErrorDetails {
    return RosettaErrorDetailsFromJSONTyped(json, false);
}

export function RosettaErrorDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): RosettaErrorDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': !exists(json, 'address') ? undefined : json['address'],
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function RosettaErrorDetailsToJSON(value?: RosettaErrorDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
        'error': value.error,
    };
}

